<template>
  <!-- before login -->
  <section>
    <!-- <main v-if="!userStore.isLogin" class="main">
            <common-login-before-Header @openContent="showMenuContent" :isShow="showContent" @openDialog="betaClickHandler" />
            <common-login-before-MobileMenu :isShow="showContent" @openContent="handleOpenContent"/>
            <div class="overlay-bg" v-if="overlayBg && showContent" @mousedown="handleOverlay" @touchend="handleOverlay"></div>
            <section :class="[`main__content`, {[`is-main-page`]: isIndex}]">
                <slot />
            </section>
            <common-login-before-Footer />
        </main> -->

    <!-- after login -->
    <main class="main after-login">
      <section class="sidebar" :class="{ fold: sideIsFold, open: !sideIsFold }">
        <CommonLoginAfterSideBar
          @menuFolding="handleMenuFolding"
          v-if="shouldShowAfterHeader"
        />
      </section>
      <AfterHeader
        v-if="shouldShowAfterHeader"
        @openContent="showMenuContent"
        :isShow="showContent"
        :foldingMenu="sideIsFold"
      />
      <CommonLoginAfterMobileMenu
        :isShow="showContent"
        @openContent="handleOpenContent"
      />
      <div
        class="overlay-bg"
        v-if="overlayBg && showContent"
        @mousedown="handleOverlay"
        @touchend="handleOverlay"
      ></div>
      <section
        :class="[
          `main__content`,
          { [`is-main-page`]: isIndex },
          { ['is-chart-only']: !shouldShowAfterHeader },
        ]"
      >
        <slot />
      </section>
      <CommonLoginAfterNav />
    </main>

    <commonLoginBetaPopup
      :dialogVisible="betaPopup"
      @closeDialog="betaClickHandler(false)"
    />
    <commonLoginCoinListPopup
      :dialogVisible="coinListPopup"
      @closeDialog="coinListClickHandler(false)"
    />

    <!-- <div v-if="!showContent" @click="windowTopHandler" class="top-btn">
            <button class="sentence sentence__600">
                TOP
            </button>
        </div> -->
  </section>
</template>

<script setup>
import AfterHeader from "@/components/common/login/after/Header.vue";
import CommonLoginAfterSideBar from "@/components/common/login/after/SideBar.vue";
import CommonLoginAfterMobileMenu from "@/components/common/login/after/MobileMenu.vue";
import CommonLoginAfterNav from "@/components/common/login/after/Nav.vue";
import commonLoginBetaPopup from "@/components/common/login/BetaPopup.vue";
import commonLoginCoinListPopup from "@/components/common/login/coinListPopup.vue";
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
// import {ref,onMounted,onBeforeUnmount} from 'vue';
import { ref } from "vue";
import { useRoute } from "vue-router";
const overlayBg = ref(false);
const showContent = ref(false);
const foldingMenu = ref(false);
// const userStore           = useUserStore();
const store = useStore();
// const menuStore           = useMainMenuList();
// console.log(menuStore);

const mainMenu = computed(() => store.getters["useMainMenuList/mainMenuItems"]);
onMounted(() => {});
const betaPopup = computed(() => store.getters["usePopupList/betaPopup"]);
const coinListPopup = computed(
  () => store.getters["usePopupList/coinListPopup"]
);
// const mainMenu            = mainMenuItems;
const sideIsFold = ref(false);
const isIndex = ref(false);

const shouldShowAfterHeader = computed(() => {
  return route.path !== "/kibot/chart";
});

const route = useRoute();
const dialogVisible = ref(false);
// // const inquiryPopupVisible = ref(false);

// // const userData     = userStore.getUserInfo();
// // const isLogin      = ref(userStore.isLogin);

if (route.path === "/" && route.name === "index") {
  isIndex.value = true;
} else {
  isIndex.value = false;
}
onMounted(async () => {
  window.addEventListener("resize", handleResize);
  window.addEventListener("keydown", handleOverlay);
  // showContent.value = false;
});

// onBeforeUnmount(() => {
//     window.removeEventListener('resize', handleResize);
//     window.removeEventListener('keydown', handleOverlay);
// });

const showMenuContent = (showContentValue) => {
  overlayBg.value = !overlayBg.value;
  showContent.value = showContentValue;
  console.log("showContent", showContentValue.value);
};

const betaClickHandler = (showPopup) => {
  // popupStore.openBetaPopup(showPopup);
  store.dispatch("usePopupList/openBetaPopup", showPopup);
  //1:1 문의팝업
  // popupStore.openInquiryModal(false);
};

const coinListClickHandler = (showPopup) => {
  // popupStore.openBetaPopup(showPopup);
  store.dispatch("usePopupList/openCoinListPopup", showPopup);
  //1:1 문의팝업
  // popupStore.openInquiryModal(false);
};

const handleMenuFolding = (menuFolding) => {
  if (menuFolding != !menuFolding) {
    sideIsFold.value = menuFolding;
    foldingMenu.value = menuFolding;
  }
  //     setFoldStauts(menuFolding);
};

const handleResize = () => {
  if (window.innerWidth === 1400) {
    setVisibleVariables(false);
  } else if (window.innerWidth > 1400) {
    setVisibleVariables(false);
  }
};

const handleOverlay = (e) => {
  if (!overlayBg.value) return;

  switch (e.type) {
    case "mousedown":
      setVisibleVariables(false);
      break;
    case "keydown":
      if (e.code !== "Escape") return;
      setVisibleVariables(false);
      break;
  }
};

const handleOpenContent = (value) => {
  if (value) {
    setVisibleVariables(false);
  }
};

const setVisibleVariables = (value) => {
  showContent.value = value;
  overlayBg.value = value;
  dialogVisible.value = false;
  console.log("showContent", showContent.value);
};

// const windowTopHandler = () => {
//     window.scrollTo({top: 0, behavior:"smooth"})
// }

// watch(userStore.userData, (newVal) => {
//     if(newVal) {
//         // foldingMenu.value = false;
//         setFoldStauts(false);
//         mainMenu.forEach(ob => {
//             if(ob.hasSubmenu && ob.beta) {
//                 if(ob.isActive) return;
//                 ob.subMenuToggle = false;
//                 ob.depth = 1;
//             }
//         })
//     }
// })

watch(
  () => route.path,
  (newPath) => {
    const allMenuItems = store.state.useMainMenuList.menuList.flatMap(
      (menu) => [menu, ...menu.subMenu]
    );

    const currentMenuItem = allMenuItems.find((item) => item.route === newPath);

    if (currentMenuItem) {
      store.dispatch("useMainMenuList/setMenuStatus", currentMenuItem.key);
    }
  },
  {
    immediate: true,
  }
);
</script>
<style lang="scss" scoped>
@import "@/assets/scss/layouts/default.scss";
</style>
